<template>
    <div class="righttop" ref="charts" style="width: 100%; height: 100%;"></div>
</template>

<script>
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/toolbox');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/dataZoom');
    export default {
        name: "PillarsView",
        props: {
            series: {
                type: Array,
                default() { return [] }
            },
            project: {
                type: Array,
                default() { return [] }
            },
            // 金额口径：true 时提示 / y 轴按「¥ + 千分位」展示（订单统计用）；
            // 不传则保持原样，不影响课时统计等页面。
            money: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.mycharts()
            window.addEventListener('resize', this.resizeChart)
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.resizeChart)
            if (this.chart) {
                this.chart.dispose()
                this.chart = null
            }
        },
        watch: {
            series() {
                this.mycharts()
            },
            project() {
                this.mycharts()
            }
        },
        methods: {
            resizeChart() {
                if (this.chart) this.chart.resize()
            },
            fmtNumber(v) {
                const n = Number(v)
                return isNaN(n) ? v : n.toLocaleString('zh-CN')
            },
            mycharts() {
                let that = this;
                if (!this.$refs.charts) return;
                if (!this.chart) {
                    this.chart = echarts.init(this.$refs.charts, "macarons");
                } else {
                    this.chart.clear();
                }
                let myChart = this.chart;
                const categories = Array.isArray(this.project) ? this.project : [];
                const money = this.money;
                // 分类较多时才开启缩放滑块；分类少时全部平铺，避免柱子被拉宽、还要手动拖动
                const showZoom = categories.length > 12;
                myChart.off('click')
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        formatter: function (params) {
                            if (!params || !params.length) return '';
                            const p = params[0];
                            const val = that.fmtNumber(p.value);
                            return p.axisValue + '<br/>' + p.marker + (money ? ('¥ ' + val) : val);
                        }
                    },
                    legend: { left: '0%', top: 0 },
                    grid: {
                        left: 12,
                        right: 20,
                        top: 30,
                        bottom: showZoom ? 60 : 44,
                        containLabel: true
                    },
                    dataZoom: showZoom ? [{
                        type: 'slider',
                        show: true,
                        start: 0,
                        end: 100,
                        height: 14,
                        bottom: 8
                    }] : [],
                    xAxis: {
                        type: 'category',
                        data: categories,
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: { color: '#DCDFE6' }
                        },
                        axisLabel: {
                            interval: 0,
                            rotate: categories.length > 6 ? 40 : 0,
                            margin: 10,
                            color: '#606266'
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: money ? '金额(元)' : '',
                        nameTextStyle: { color: '#909399' },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            color: '#909399',
                            formatter: function (value) {
                                return money ? that.fmtNumber(value) : value;
                            }
                        },
                        splitLine: {
                            lineStyle: { type: 'dashed', color: '#EBEEF5' }
                        }
                    },
                    series: this.series
                })
                myChart.resize()
                myChart.on('click', function (params) {
                    that.$emit('histogramDetailed', params.dataIndex);
                })
            }
        }
    }
</script>

<style scoped>

</style>
